import React, { useState } from "react";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Show from "../../../../utils/show.component";

export const TravelExemptionDatePicker = (props) => {
  const { change, selected, fieldName, labelText, minDate } = props;
  const [calendarOpen, setCalendarOpen] = useState(false);

  const wrapperClasses = props.wrapperClasses ? props.wrapperClasses : "";

  return (
    <div className={wrapperClasses}>
      <label htmlFor={fieldName}>{labelText}</label>
      <div className="mb-3">
        <button
          className="d-flex p-2"
          style={{ color: "white", backgroundColor: "#00558c", width: "240px" }}
          type="button"
          onClick={() => setCalendarOpen((state) => !state)}
        >
          <i className="material-icons pl-1 pr-5">calendar_month</i>
          {moment(selected).format("ddd, M/D")}
        </button>
      </div>
      <Show condition={calendarOpen}>
        <div className="mb-3">
          <DatePicker
            selected={selected}
            name={fieldName}
            id={fieldName}
            minDate={minDate}
            onChange={(date) => {
              change(fieldName, date);
              setCalendarOpen(false);
            }}
            placeholderText="Select a date"
            data-e2e-id={fieldName + "-date-picker"}
            inline
          />
        </div>
      </Show>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/card-controls/forms/field-components/travel-exemption-date-picker.component.js